export const MARKET_TODAY = "MARKET_TODAY";
export const MARKET_TODAY_STREAM = "MARKET_TODAY_STREAM";
export const MARKET_TODAY_START_LOADER = "MARKET_TODAY_START_LOADER";
export const MARKET_TODAY_STOP_LOADER = "MARKET_TODAY_STOP_LOAD";
export const MARKET_TODAY_ERROR = "MARKET_TODAY_ERROR";
export const MARKET_TODAY_HIDE_ERROR = "MARKET_TODAY_HIDE_ERROR";
